export const isDteRejectedError = (error: any): boolean =>
  error?.response?.status === 422 && error?.response?.data?.type === 'DTE_REJECTED';

export const parseDteRejectedObservations = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(String);
  return String(value || '')
    .replace(/^\[|\]$/g, '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};
